'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { getProductFeatureDescriptionKey } from 'self-service-api/core/utilities/getFeatureDescriptionKey';
import ChecklistItem from 'pricing-pages-unified-ui/components/common/ChecklistItem';
import ViewAllFeatures from '../product-pages/ViewAllFeatures';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import ProductLineToGaMap from '../../constants/ProductLineToGaMap';
import { FREE_CARD } from '../../constants/Tracking'; // import { FreeHighlightedFeatures } from 'self-service-api/constants/HighlightedFeatures';
// import { isUngatedForFeatureStore } from '../../selectors/GatingSelectors';
// import { useSelector } from 'react-redux';
// import {
//   featuresForHighlightedProductsSelector,
//   fetchFeaturesStatus,
// } from '../../selectors/FeatureSelectors';
// import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';

import FreeCardFeatureMap from 'pricing-pages-unified-ui/constants/FreeCardFeatureMap'; // import RequestStatus from '../../constants/RequestStatus';
// import ChecklistItemFS from './ChecklistItemFS';

const FeaturesContainer = styled.div.withConfig({
  displayName: "FreeCardFeatures__FeaturesContainer",
  componentId: "sc-1rv5x7e-0"
})(["display:flex;", ""], breakpoint.tablet(_t || (_t = _`
    flex-direction: column;

  `)));
const DesktopFeaturesContainer = styled.div.withConfig({
  displayName: "FreeCardFeatures__DesktopFeaturesContainer",
  componentId: "sc-1rv5x7e-1"
})(["margin-left:8px;", " ", ""], breakpoint.tablet(_t2 || (_t2 = _`
    margin-top: 4px;
  `)), breakpoint.phoneLarge(_t3 || (_t3 = _`
    display: none;
  `)));

const FreeCardFeatures = ({
  productLine
}) => {
  // const isUngatedForFS = useSelector(isUngatedForFeatureStore);
  // const featuresStatus = useSelector(fetchFeaturesStatus);
  // const { highlightedFreeProduct } = FullProductLineMap[productLine];
  // const productLineFeatures = useSelector(state => {
  //   return featuresForHighlightedProductsSelector(state, {
  //     highlightedProducts: [highlightedFreeProduct],
  //   });
  // });
  // if (!isUngatedForFS) {
  return /*#__PURE__*/_jsxs(FeaturesContainer, {
    children: [FreeCardFeatureMap[productLine].map(feature => /*#__PURE__*/_jsx(ChecklistItem, {
      tooltipMessage: getProductFeatureDescriptionKey(feature, productLine),
      message: `pricing-pages.features.${feature}.name`,
      className: "m-right-5"
    }, feature)), /*#__PURE__*/_jsx(DesktopFeaturesContainer, {
      children: /*#__PURE__*/_jsx(ViewAllFeatures, {
        productLine: productLine,
        use: "inline",
        gaClassName: getGAClassName(`${ProductLineToGaMap[productLine]}free-pricing-features`),
        trackingSource: FREE_CARD
      })
    })]
  }); // }
  // if (featuresStatus !== RequestStatus.SUCCEEDED || !highlightedFreeProduct) {
  //   return null;
  // }
  // return (
  //   <FeaturesContainer>
  //     {FreeHighlightedFeatures[productLine].map(feature => {
  //       if (
  //         productLineFeatures &&
  //         productLineFeatures[highlightedFreeProduct] &&
  //         productLineFeatures[highlightedFreeProduct][feature]
  //       ) {
  //         return (
  //           <ChecklistItemFS
  //             key={feature}
  //             tooltipMessage={
  //               productLineFeatures[highlightedFreeProduct][feature].description
  //             }
  //             message={
  //               productLineFeatures[highlightedFreeProduct][feature].displayName
  //             }
  //             className="m-right-5"
  //           />
  //         );
  //       }
  //       return null;
  //     })}
  //     <DesktopFeaturesContainer>
  //       <ViewAllFeatures
  //         productLine={productLine}
  //         use="inline"
  //         gaClassName={getGAClassName(
  //           `${ProductLineToGaMap[productLine]}free-pricing-features`
  //         )}
  //         trackingSource={FREE_CARD}
  //       />
  //     </DesktopFeaturesContainer>
  //   </FeaturesContainer>
  // );
};

export default FreeCardFeatures;